import StatisticsCard from "../../components/Fleet/StatisticsCard/StatisticsCard";

const FleetHomePage = () => {
  return <StatisticsCard />;
};

export default FleetHomePage;
